import Dashboard from "pages/Dashboard/Dashboard"
import Login from "pages/Login"
import User from "pages/Setting/User/User"
import UserForm from "pages/Setting/User/UserForm"
import Setting from "pages/Setting/Setting"
import Client from "pages/Client/Client"
import ClientForm from "pages/Client/ClientForm"
import CustomerLogin from "pages/CustomerLogin/CustomerLogin"
import CustomerLoginForm from "pages/CustomerLogin/CustomerLoginForm"

export const routes = [
   {
      path: "/login",
      element: <Login />
   },
   {
      path: "/",
      element: <Dashboard />
   },
   {
      path: "/client",
      element: <Client />
   },
   {
      path: "/client/form",
      element: <ClientForm />
   },
   {
      path: "/customer-login",
      element: <CustomerLogin />
   },
   {
      path: "/customer-login/form",
      element: <CustomerLoginForm />
   },



   {
      path: "/setting",
      element: <Setting />
   },
   {
      path: "/setting/user",
      element: <User />
   },
   {
      path: "/setting/user/form",
      element: <UserForm />
   },
]

export const ROLE_ADMIN = "admin"
export const ROLE_OWNER = "owner"